/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import './editButton.scss';
import { ReactComponent as Edit } from '../../assets/edit.svg';
import { EDIT_BUTTON_TYPE, EditInterface } from './editButtonTypes';

const EditButton: React.FC<EditInterface> = ({ onClick, ver, animation }) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    onClick();
  };

  const Primary = () => (
    <button
      className={animation ? 'editButton' : 'editButtonNoHover'}
      type="button"
      onClick={handleClick}
    >
      <Edit className={animation ? 'editIcon' : 'editIconNoHover'} />
    </button>
  );

  const Secondary = () => (
    <button
      className={
        animation ? 'editButtonSecondary' : 'editButtonSecondaryNoHover'
      }
      type="button"
      onClick={handleClick}
    >
      <Edit
        className={animation ? 'editIconSecondary' : 'editIconSecondaryNoHover'}
      />
    </button>
  );

  return ver === EDIT_BUTTON_TYPE.PRIMARY ? <Primary /> : <Secondary />;
};

export default EditButton;
